import { clearSnapshots } from "./snapshots";
import { rememberSubForWorker } from "./sub-for-worker";

/**
 * Signing out: this device forgets what it was shown and who it was shown to (US-33.4).
 *
 * <p>What it does <strong>not</strong> forget is the queue. A card typed in a cellar and not yet
 * sent is work; deleting it because somebody pressed "sign out" would be deleting work. It stays,
 * and the next person to sign in is told there are saves here that are not theirs, with a Delete
 * button — a decision somebody takes, rather than one a log-out takes for them.
 */
export async function forgetOfflineData(sub: string): Promise<void> {
  await clearSnapshots(sub);
  await rememberSubForWorker(undefined);
}
